// extracted by mini-css-extract-plugin
export var card = "_kq-5";
export var cardSelected = "_kq-4";
export var image = "_kq-3";
export var modal = "_kq-0";
export var modalContent = "_kq-1";
export var table = "_kq-2";